import * as actionTypes from '../actionTypes/logErrorActionTypes'
import { LogErrorState } from '../types/logError'

const initialState: LogErrorState = {
  isLoading: false,
  data: { logerror: null },
  timestamp: null,
  error: null,
}

const logErrorReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.LOG_ERROR_INFO:
      return {
        ...state,
        isLoading: true,
      }
    case actionTypes.LOG_ERROR_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: { logerror: action.payload },
        error: null,
      }
    case actionTypes.LOG_ERROR_INFO_FAILED:
      return {
        ...state,
        isLoading: false,
        data: { logerror: null },
        error: action.payload.error,
      }
    default:
      return {
        ...state,
      }
  }
}

export default logErrorReducer
